import axiosInstance from "../../../constants/axiosInstance";
import { fMpathConstants } from "../fileManagerConstants";
import { DeleteFilePayload, FMListingQueryKeyDataInterface } from "../types";

const fMDocumentsLists = async ({ pageParam, queryKey}: {pageParam: number;  queryKey: FMListingQueryKeyDataInterface}) => {
  try {
    const [, id, searchString, selectedCategory, selectedSubCategory, fileTypeFiltersCollection ] = queryKey;
    const { data } = await axiosInstance().post(fMpathConstants.FMListingPath, {assetId: id, limit: 20, pageNumber: pageParam, search: searchString || '', category: selectedCategory || '', subCategory: selectedSubCategory || '', fileTypes: fileTypeFiltersCollection || []});
    return {
      ...data,
      currentPage: pageParam,
    };
  } catch (err) {
    throw err;
  }
}

const fetchLists = async (payload: any, path: string) => {
  try {
    const { data } = await axiosInstance().post(path, payload);
    return data.data;
  } catch (err) {
    throw err;
  }
}

const fmFileUpload = async (payload: any) => {
  try {
    const response = await axiosInstance().post(fMpathConstants.FMUploadPath, payload);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const deleteFile = async (payload: DeleteFilePayload): Promise<{ message?: string }> => {
  try {
    const { data } = await axiosInstance().post(
      fMpathConstants.FMDeletePath,
      payload
    );
    return data.data;
  } catch (err) {
    console.error('Company Listing api Error');
    throw err;
  }
};

export {
  fMDocumentsLists,
  fetchLists,
  fmFileUpload,
  deleteFile
}